import React, { useEffect } from "react";
import "./aboutUs.css";
import Navbar from "../../components/navbar/Navbar";
import Footer from "../../components/footer/Footer";
import GetStartedSection from "../../components/getStartedSection/GetStartedSection";
import { useLocation } from "react-router-dom";
import SEO from "../../components/SEO/SEO";

const AboutUs = () => {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);
  return (
    <div>
      <SEO
        title="About Us"
        description="About Swadaa Security & Guards Limited: a Lagos-based security company delivering trained guards, surveillance, and empowerment programs for businesses, events, and communities. Learn about our mission, expertise, and government partnerships."
        keywords="Swadaa Security, about Swadaa Security, Lagos security company, private security firm, community safety, empowerment programs, security partnerships"
      />
      <Navbar />
      <div className="homeAbout_sectionOneCont">
        <div className="homeAbout_sectionOne_gen">
          <div className="homeAbout_startedHeader">
            About <span className="homeAbout_startedSub">Us</span>{" "}
          </div>

          <div className="about_us_content_wrapper">
            <div className="about_us_card">
              <div className="about_us_card_title">
                {/* <span className="card_icon">🎯</span> */}
                Our Mission
              </div>
              <div className="about_us_para">
                To provide dependable security guard services that protect
                lives, properties, businesses, and events through highly trained
                personnel, professionalism, integrity, and proactive security
                measures.
              </div>
            </div>

            <div className="about_us_card">
              <div className="about_us_card_title">
                {/* <span className="card_icon">👁️</span> */}
                Our Vision
              </div>
              <div className="about_us_para">
                SWADAA is a government-approved non-profit organization in
                partnership with NDLEA, committed to raising awareness on drug
                abuse and promoting healthy, drug-free lifestyles among youths.
                Through education, outreach, and community engagement, we
                actively work across schools, institutions, and communities to
                build a safer, drug-free society.
              </div>
            </div>

            <div className="about_us_card">
              <div className="about_us_card_title">
                {/* <span className="card_icon">🔒</span> */}
                Security Services
              </div>
              <div className="about_us_para">
                SWADAA Security and Guards Services provides reliable and
                professional protection for businesses, residences, events, and
                institutions. With trained personnel and effective security
                strategies, we deliver manned guarding, surveillance, risk
                assessment, and rapid response services tailored to each
                client’s needs.
              </div>
            </div>

            <div className="about_us_card">
              <div className="about_us_card_title">
                {/* <span className="card_icon">💪</span> */}
                Empowerment Programs
              </div>
              <div className="about_us_para">
                We support women, youth, and widows through training,
                mentorship, and skills development initiatives. Our programs are
                designed to promote self-reliance, inclusivity, and economic
                empowerment, helping individuals build better and more stable
                livelihoods.
              </div>
            </div>
          </div>
        </div>
      </div>

      <GetStartedSection />
      <Footer />
    </div>
  );
};

export default AboutUs;
